var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person)?_c('ion-card',[_c('b',[_vm._v(_vm._s(_vm.heading))]),_c('img',{attrs:{"src":_vm.person.picture}}),_c('ion-card-title',[_vm._v(_vm._s(_vm.person.name))]),_c('ion-card-content',[_vm._v(_vm._s(_vm.person.description))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }